import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Membranes bitumineuses", href: "/services/membranes-bitumineuses" },
  { label: "Géomembranes EPDM", href: "/services/geomembranes-epdm" },
  { label: "Réfection étanchéité", href: "/services/refection-etancheite" },
  { label: "Toitures-terrasses", href: "/services/toitures-terrasses" },
  { label: "Terrasses", href: "/services/terrasses" },
];

export default function EtancheiteLiquidePage() {
  return (
    <ServicePageLayout
      tag="Technique innovante"
      title="Étanchéité liquide"
      subtitle="Résines et revêtements liquides haute performance pour toitures complexes, terrasses accessibles et ouvrages à géométrie variable."
      heroImage="https://readdy.ai/api/search-image?query=professional%20worker%20applying%20liquid%20waterproofing%20resin%20coating%20on%20flat%20rooftop%20terrace%2C%20roller%20application%20of%20grey%20liquid%20membrane%2C%20smooth%20seamless%20surface%2C%20modern%20building%2C%20professional%20construction%20photography%2C%20bright%20daylight&width=1440&height=900&seq=ksbtp-el-hero-001&orientation=landscape"
      heroAlt="Application d'étanchéité liquide KS BTP"
      intro="L'étanchéité liquide est la solution idéale pour les ouvrages à géométrie complexe, les terrasses accessibles et les zones difficiles d'accès. Appliquée en une ou plusieurs couches au rouleau ou à la taloche, la résine polyuréthane ou PMMA forme un revêtement continu, sans joint ni soudure, épousant parfaitement toutes les formes. KS BTP utilise des produits certifiés ATEC/DTA et intervient sur toitures-terrasses, balcons, coursives, parkings couverts et ouvrages de génie civil. La mise en œuvre est rapide, propre et sans odeur gênante."
      techItems={[
        { icon: "ri-drop-fill", label: "Résine polyuréthane (PU)" },
        { icon: "ri-flashlight-line", label: "Résine PMMA ultra-rapide" },
        { icon: "ri-layout-grid-line", label: "Revêtement sans joint continu" },
        { icon: "ri-walk-line", label: "Terrasses accessibles piétons" },
        { icon: "ri-car-line", label: "Parkings couverts & coursives" },
        { icon: "ri-palette-line", label: "Finitions colorées & antidérapantes" },
      ]}
      steps={[
        {
          number: "01",
          title: "Analyse du support",
          description: "Évaluation de la planéité, de la résistance à la traction et de l'humidité résiduelle du support pour garantir l'adhérence de la résine.",
        },
        {
          number: "02",
          title: "Préparation & primaire",
          description: "Ponçage ou grenaillage du support, traitement des fissures et application d'un primaire d'accrochage adapté au type de résine.",
        },
        {
          number: "03",
          title: "Application de la résine",
          description: "Mise en œuvre en 2 à 3 couches avec armature de renfort aux points singuliers, relevés et angles. Séchage rapide entre les couches.",
        },
        {
          number: "04",
          title: "Finition & réception",
          description: "Application de la couche de finition (colorée ou antidérapante), test d'adhérence et remise du dossier de garantie.",
        },
      ]}
      advantages={[
        "Revêtement continu sans joint ni soudure, zéro risque de décollement",
        "Adapté aux géométries complexes : angles, relevés, pénétrations, noues",
        "Mise en œuvre rapide — retour à l'usage en quelques heures pour les résines PMMA",
        "Application propre sans flamme ni odeur forte, idéale en milieu occupé",
        "Finitions personnalisables : couleur, antidérapant, aspect lisse ou granulé",
        "Compatible avec les supports béton, bois, acier et anciens revêtements",
        "Garantie décennale et produits certifiés ATEC/DTA",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=worker%20applying%20liquid%20polyurethane%20waterproofing%20membrane%20with%20roller%20on%20rooftop%20terrace%2C%20smooth%20grey%20seamless%20coating%2C%20professional%20application%2C%20modern%20urban%20building%20background%2C%20construction%20site%20photography&width=600&height=440&seq=ksbtp-el-gal-001&orientation=landscape",
          alt: "Application résine polyuréthane au rouleau",
        },
        {
          src: "https://readdy.ai/api/search-image?query=finished%20liquid%20waterproofing%20coating%20on%20accessible%20rooftop%20terrace%20with%20outdoor%20furniture%2C%20smooth%20light%20grey%20seamless%20surface%2C%20modern%20architecture%2C%20clean%20professional%20result&width=600&height=440&seq=ksbtp-el-gal-002&orientation=landscape",
          alt: "Terrasse accessible avec étanchéité liquide terminée",
        },
        {
          src: "https://readdy.ai/api/search-image?query=liquid%20waterproofing%20resin%20applied%20on%20complex%20rooftop%20with%20pipes%20and%20penetrations%2C%20seamless%20coating%20around%20obstacles%2C%20professional%20waterproofing%20detail%20work%2C%20construction%20photography&width=600&height=440&seq=ksbtp-el-gal-003&orientation=landscape",
          alt: "Étanchéité liquide autour des pénétrations",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
